const scroll = {
  inserted: (el, binding) => {
    window.addEventListener('scroll', binding.value)
  },
  unbind: (el, binding) => {
    window.removeEventListener('scroll', binding.value)
  }
}

const resize = {
  inserted: (el, binding) => {
    window.addEventListener('resize', binding.value)
  },
  unbind: (el, binding) => {
    window.removeEventListener('resize', binding.value)
  }
}

const accordeon = {
  inserted: (el, binding) => {
    const m = el.querySelector('.menu-list')
    m.style.transition = 'all .2s'
    m.style.overflow = 'hidden'
    m.style.margin = 0
    m.style.maxHeight = 0
  },
  componentUpdated: (el, binding) => {
    const m = el.querySelector('.menu-list')
    m.style.maxHeight = binding.value ? m.scrollHeight + 'px' : 0
    m.style.margin = binding.value ? null : 0
    el.classList.toggle('open', binding.value)
  }
}

const doIfOther = (el, binding) => (e) => {
  if (!el.contains(e.target) && el !== e.target) {
    binding()
  }
}

const clickOutside = {
  // call the binded callback if click not on yourself element
  inserted: (el, binding) => {
    window.addEventListener('click', doIfOther(el, binding.value))
  },
  unbind: (el, binding) => {
    window.removeEventListener('click', doIfOther(el, binding.value))
  }
}

export { scroll, resize, accordeon, clickOutside }
